import { Link } from "react-router-dom";
import { Leaf, Sparkles, ArrowRight } from "lucide-react";
import { NUTRIZIONE_INFO } from "@/data/siteData";

export default function NutrizioneTeaser() {
  return (
    <section className="relative py-24 md:py-32 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Link
          to="/nutrizione"
          data-testid="home-nutrizione-teaser"
          className="group relative block rounded-3xl overflow-hidden shadow-[0_20px_60px_rgba(47,74,60,0.18)] hover:shadow-[0_30px_80px_rgba(47,74,60,0.25)] transition-all duration-500 hover:-translate-y-1"
          style={{ backgroundColor: "#2F4A3C" }}
        >
          <div className="absolute inset-0">
            <img
              src={NUTRIZIONE_INFO.heroImage}
              alt="Nutrizione clinica"
              className="w-full h-full object-cover opacity-50 group-hover:opacity-55 transition-opacity duration-700"
              style={{ objectPosition: "center 60%" }}
              loading="lazy"
            />
            <div
              className="absolute inset-0"
              style={{
                background:
                  "linear-gradient(100deg, rgba(47,74,60,0.95) 0%, rgba(47,74,60,0.82) 45%, rgba(47,74,60,0.4) 85%, rgba(47,74,60,0.25) 100%)",
              }}
            />
          </div>

          <div className="relative px-8 py-16 md:px-16 md:py-20 lg:px-20 lg:py-24 max-w-3xl">
            <span className="inline-flex items-center gap-1.5 bg-[#C6A86B] text-[#2F4A3C] text-[10px] font-semibold tracking-[0.22em] uppercase px-3 py-1.5 rounded-full">
              <Sparkles size={11} strokeWidth={2.2} /> Novità · Da novembre 2026
            </span>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-6 text-white leading-[1.02]">
              Nutrizione clinica
            </h2>
            <p className="mt-4 font-serif italic text-xl md:text-2xl text-[#C6A86B]">
              Diete sartoriali, cucite addosso al paziente.
            </p>
            <p className="mt-6 text-white/75 leading-relaxed max-w-2xl">
              Percorsi personalizzati per colon irritabile (FODMAP), celiachia,
              diabete, dislipidemie, sindrome metabolica, pancreatite e altre
              condizioni cliniche. Cinque pacchetti su misura.
            </p>

            <span className="inline-flex items-center gap-2 mt-10 bg-[#C6A86B] text-[#2F4A3C] px-7 py-4 rounded-full text-sm font-semibold group-hover:bg-[#D4B97F] transition-all">
              <Leaf size={16} strokeWidth={1.8} />
              Scopri i pacchetti
              <ArrowRight
                size={16}
                strokeWidth={2}
                className="transition-transform group-hover:translate-x-1"
              />
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
}
